<template><svg width="12" height="2" viewBox="0 0 12 2" xmlns="http://www.w3.org/2000/svg"><path d="M0 0H12V2H0V0Z"/></svg></template>